module.exports = __webpack_public_path__ + "static/media/jiaming-prof.8fb37cc2.svg";